import React, { PureComponent } from 'react';
import classnames from 'classnames';

import { Icon } from '@eb/eds-icon';
import { StatusDotChunky } from '@eb/eds-iconography';

import { EVENT_SALES_STATUS_INFO_SHAPE } from '../constants';
import StatusDate from './StatusDate';

import {
    getSalesStatusIconColor,
    getSalesStatusLabel,
    eventIsDraft,
    eventIsScheduledPublish,
    eventIsNotYetOnSale,
    shouldShowSalesStatusIcon,
} from './utils';

export default class SalesStatusColumn extends PureComponent {
    static propTypes = {
        statusInfo: EVENT_SALES_STATUS_INFO_SHAPE.isRequired,
    };

    render() {
        const {
            statusInfo: {
                status,
                eventSalesStatus,
                publishSettings = {},
                start = {},
            },
        } = this.props;
        const isScheduledPublish = eventIsScheduledPublish(publishSettings);
        const isNotYetOnSale = eventIsNotYetOnSale(eventSalesStatus);
        const isDraft = eventIsDraft(status);
        const label = getSalesStatusLabel({
            status,
            isScheduledPublish,
            ...eventSalesStatus,
        });
        const shouldShowIcon = shouldShowSalesStatusIcon({
            isScheduledPublish,
            eventSalesStatus,
            eventStatus: status,
        });
        let statusDate;

        // Need to have the empty div to hold the empty space the icon would take up
        let icon = <div className="eds-g-cell eds-g-cell-2-12" />;

        if (shouldShowIcon) {
            icon = (
                <div
                    className="eds-g-cell eds-g-cell-2-12"
                    data-spec="event-status-badge-icon"
                >
                    <Icon
                        type={<StatusDotChunky />}
                        color={getSalesStatusIconColor({
                            isScheduledPublish,
                            status,
                            salesStatus:
                                eventSalesStatus &&
                                eventSalesStatus.salesStatus,
                        })}
                        __containerClassName="eds-l-pad-right-1"
                    />
                </div>
            );
        }

        if (isScheduledPublish) {
            const { schedulePublishDate } = publishSettings;
            const { timezone } = start;

            statusDate = (
                <StatusDate utc={schedulePublishDate} timezone={timezone} />
            );
        } else if (!isDraft && isNotYetOnSale) {
            const { startSalesDate: { utc, timezone } = {} } = eventSalesStatus;

            statusDate = <StatusDate utc={utc} timezone={timezone} />;
        }
        const statusLabelClassNames = classnames(
            'event-status-badge-label',
            'eds-g-cell',
            'eds-g-cell-10-12',
            'eds-l-pad-left-1',
        );

        return (
            <div className="eds-grid">
                <div className="eds-g-group">
                    <div className="eds-g-cell eds-g-cell-12-12">
                        {icon}
                        <div
                            className={statusLabelClassNames}
                            data-spec="event-status-badge-label"
                        >
                            {label}
                        </div>
                    </div>
                </div>
                {statusDate}
            </div>
        );
    }
}
